import React from 'react'
import PropTypes from 'prop-types'

import { StyledListItem, InfoWrapper, PoiName, DistanceWrapper, DistanceName } from './style'

import PoiIcon from '../../../../../../ui/PoiIcon'
import TravelIcon from '../../../../../../ui/TravelIcon'

const Poi = React.memo(({ distanceText, poiType, poiTypeId, travelType }) => (
  <StyledListItem>
    <InfoWrapper>
      <PoiIcon typeId={poiTypeId} props={{ fill: '#81736E', height: '32', width: '32' }} />
      <PoiName>{poiType}</PoiName>
    </InfoWrapper>
    <DistanceWrapper>
      <DistanceName>{distanceText}</DistanceName>
      <TravelIcon type={travelType} props={{ fill: '#81736E', height: '29', width: '29' }} />
    </DistanceWrapper>
  </StyledListItem>
))

Poi.propTypes = {
  distanceText: PropTypes.string.isRequired,
  poiType: PropTypes.string.isRequired,
  poiTypeId: PropTypes.number.isRequired,
  travelType: PropTypes.string.isRequired,
}

export default Poi
